import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=68647720&scoped=true&"
import script from "./admin-dashboard.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68647720",
  null
  
)

export default component.exports